module.exports = __webpack_public_path__ + "img/snowflakes.ff4aaf45.png";